import { Routes, Route } from 'react-router-dom';
import { AuthGate, LoginPage } from '@butternetwork/shared-auth';
import { Portal } from './pages/Portal';

/**
 * Shell app routes:
 *   /login   — public login page (redirects to ?redirect=... on success)
 *   /*       — gated portal home (AuthGate protects all other routes)
 *
 * Shell itself does NOT set VITE_LOGIN_URL, so AuthGate renders <LoginPage /> inline
 * for any unauthenticated visit to "/". We also expose /login explicitly so that
 * sub-systems (which DO set VITE_LOGIN_URL=/login) can redirect here.
 */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage title="Ops Hub" />} />
      <Route
        path="/*"
        element={
          <AuthGate fallback={<LoginPage title="Ops Hub" />}>
            <Portal />
          </AuthGate>
        }
      />
    </Routes>
  );
}
